export default {
    getModelBanco: (state) => {
        return state.banco
    },
    getBancoTpl: (state) => {
        if(state.operacion==="list"){
            return "bancoList"
        }
    }
}